import * as React from "react";
const SvgFiRrWalkieTalkie = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-walkie-talkie_svg__a)">
      <path
        fill="#062147"
        d="M17 3h-5V2a1 1 0 0 0-2 0v1H7V1a1 1 0 0 0-2 0v2.418A5.01 5.01 0 0 0 2 8v3.597c0 1.131.389 2.24 1.096 3.124l.685.857a1 1 0 0 1 .219.625v2.798c0 2.757 2.243 5 5 5h6c2.757 0 5-2.243 5-5v-2.798c0-.226.078-.448.219-.625l.685-.856A5.02 5.02 0 0 0 22 11.598V8.001A5.007 5.007 0 0 0 17 3m3 8.597c0 .679-.233 1.344-.657 1.875l-.685.856A3 3 0 0 0 18 16.203v2.798c0 1.654-1.346 3-3 3H9c-1.654 0-3-1.346-3-3v-2.798c0-.679-.233-1.344-.658-1.874l-.685-.856A3 3 0 0 1 4 11.598V8.001c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3zM16 7H8c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2m-8 4V9h8v2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-walkie-talkie_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWalkieTalkie;
